import logo from './logo.png'
export default function Logo() {
    return (
        <img src={logo} style={{maxWidth: '150px'}} alt="logo" />
    )
}
